// src/utils/storage.js

// Salvar agendamento
export const saveAppointment = (appointment) => {
  try {
    // Pega agendamentos existentes ou array vazio
    const appointments = getAppointments();
    
    // Adiciona ID e timestamp
    const newAppointment = {
      ...appointment,
      id: Date.now().toString(), // ID único baseado no timestamp
      createdAt: new Date().toISOString(),
      status: 'confirmado'
    };
    
    // Adiciona ao array
    appointments.push(newAppointment);
    
    // Salva no localStorage
    localStorage.setItem('barbearia_agendamentos', JSON.stringify(appointments));
    
    return newAppointment;
  } catch (error) {
    console.error('Erro ao salvar agendamento:', error);
    return null;
  }
};

// Buscar todos agendamentos
export const getAppointments = () => {
  try {
    const data = localStorage.getItem('barbearia_agendamentos');
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Erro ao buscar agendamentos:', error);
    return [];
  }
};

// Buscar agendamentos por telefone
export const getAppointmentsByPhone = (phone) => {
  const appointments = getAppointments();
  return appointments.filter(app => app.telefone === phone);
};

// Cancelar agendamento
export const cancelAppointment = (id) => {
  try {
    const appointments = getAppointments();
    const updatedAppointments = appointments.map(app => 
      app.id === id ? { ...app, status: 'cancelado' } : app
    );
    
    localStorage.setItem('barbearia_agendamentos', JSON.stringify(updatedAppointments));
    return true;
  } catch (error) {
    console.error('Erro ao cancelar agendamento:', error);
    return false;
  }
};

// Limpar todos agendamentos (apenas para desenvolvimento)
export const clearAppointments = () => {
  localStorage.removeItem('barbearia_agendamentos');
};